export const RED_POINTS_INFORMATION_MODAL = 'redpoints-information-modal'
